/* eslint-disable react/no-unused-prop-types */
import * as React from 'react';
import { useSpring, animated } from '@react-spring/web';

type AnimationType = {
    children?: React.ReactNode;
    y?: number;
    opacity?: number;
    delay?: number;
    onRest?: () => void;
};

export const AnimationAppear: React.FC<AnimationType> = ({
    children,
    onRest,
    y: animationY,
    delay,
}) => {
    const startYposition = animationY || 28;
    const config = useSpring({
        delay,
        opacity: 1,
        transform: 'translate3d(0,0,0)',
        from: { opacity: 0, transform: `translate3d(0,${startYposition}px, 0)` },
        onRest,
    });
    return (
        <>
            {React.Children.toArray(children)
                .filter(Boolean)
                .map((item, index) => (
                    <animated.div style={config} key={item.toString() + index}>
                        {item}
                    </animated.div>
                ))}
        </>
    );
};

export const AnimationFadeIn: React.FC<AnimationType> = ({
    children,
    onRest,
    opacity = 0,
    delay,
}) => {
    const config = useSpring({
        delay,
        opacity: 1,
        transform: 'translate3d(0,0,0)',
        from: { opacity },
        onRest,
    });
    return (
        <>
            {React.Children.toArray(children)
                .filter(Boolean)
                .map((item, index) => (
                    <animated.div style={config} key={item.toString() + index}>
                        {item}
                    </animated.div>
                ))}
        </>
    );
};
